<template>
    <div class="article-details">
         <studySearch :search="'检索'" :advancedSearch="'高级检索'"  @searchClick='searchClick' @advancedSearch='advancedSearch' :sourceType="'articleDetails'"></studySearch>
         <div class="article-cont">
            <p class="article-tit" v-html="articleInfo.title"></p>
            <div class="cont">
                <p class="basic">基本信息</p>

                <div class="info" v-if="articleInfo.bookName">
                    <div class="info-label">书名</div>
                    <div class="info-txt" v-html="articleInfo.bookName"></div>
                </div>
                <div class="info" v-if="articleInfo.author">
                    <div class="info-label">作者</div>
                    <div class="info-txt" v-html="articleInfo.author">  </div>
                </div>

                <div class="info" v-if="articleInfo.dynasty">
                    <div class="info-label">朝代</div>
                    <div class="info-txt" v-html="articleInfo.dynasty"> </div>
                </div>
                <div class="info" v-if="articleInfo.classification">
                    <div class="info-label">分类</div>
                    <div class="info-txt" v-html="articleInfo.classification">  </div>
                </div>

                <div class="info" v-if="articleInfo.catalog1">
                    <div class="info-label">一级目录</div>
                    <div class="info-txt" v-html="articleInfo.catalog1">  </div>
                </div>
                <div class="info" v-if="articleInfo.catalog2">
                    <div class="info-label">二级目录</div>
                    <div class="info-txt" v-html="articleInfo.catalog2">  </div>
                </div>
                <div class="info" v-if="articleInfo.catalog3">
                    <div class="info-label">三级目录</div>
                    <div class="info-txt" v-html="articleInfo.catalog3">  </div>
                </div>
                <div class="info" v-if="articleInfo.title">
                    <div class="info-label">标题</div>
                    <div class="info-txt" v-html="articleInfo.title"> </div>
                </div>
                <div class="info" v-if="articleInfo.content">
                    <div class="info-label">内容</div>
                    <div class="info-txt" v-html="articleInfo.content">  </div>
                </div>
            </div>
         </div>
    </div>
</template>

<script> 
import studySearch from './studyPage/comps/study_search.vue'
import { entryInfo } from '../io/api'
export default {
    components: {
        studySearch,
    },
    data () {
        return {
            articleId:this.$route.query.id||'',
            searchWord:this.$route.query.searchWord||'',
            articleInfo:{},
        }
    },
    mounted(){
        this.getArticleInfo();
    },
    methods: {
        getArticleInfo(){
            let params={
                id:this.articleId,
                searchWord:this.searchWord
            }
            entryInfo(params).then(res => {
                let {code,data,msg}=res.data;
                if(code==0){
                    this.articleInfo=data.entryInfo||{};
                }else{
                    this.$message.error(msg||'获取条目信息失败');
                }
            })
        },
        searchClick(){
            
        },
        advancedSearch(){
            
        },
    }
}
</script>

<style lang="less" scoped>
.article-details{
    min-width: 1200px;
    margin: 0 auto;
    .article-cont{
        width: 1200px;
        margin: 40px auto;
        padding:30px;
        box-shadow: 0px 3px 12px 0px #c4bfbc;

        .article-tit{
            font-weight: bold;
            margin-bottom: 10px;
            font-size: 24px;
        }
        .cont{
            border: 1px solid #dadada;
            border-bottom:none; 
            line-height: 28px; 
        }
        .basic{
            background: #efefef;
            padding:0 10px;
            border-bottom: 1px solid #dadada;
            min-height: 28px; 
            padding:6px 10px;
            font-size: 16px;
            font-weight: bold;
        }
        .info{
            display: flex;
            justify-content: space-between;
            padding:6px 10px;
            border-bottom: 1px solid #dadada;
            min-height: 28px;  
            .info-label{
                width: 120px;
                flex-shrink: 0;
                font-weight: bold;
            }
            .info-txt{
                width: 960px; 
            }
        }
    }
}
</style>